import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ExportItemizedSpreadsheetDataModalContainer, type ExportItemizedSpreadsheetDataModalContainerProps,
} from './exportItemizedSpreadsheetData.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ExportItemizedSpreadsheetData: ExportItemizedSpreadsheetDataModalContainerProps;
  }
}
modalRenderer.register('ExportItemizedSpreadsheetData', ExportItemizedSpreadsheetDataModalContainer);
